import { render, staticRenderFns } from "./technological.vue?vue&type=template&id=4c9d04ee&scoped=true"
import script from "./technological.vue?vue&type=script&lang=js"
export * from "./technological.vue?vue&type=script&lang=js"
import style0 from "./technological.vue?vue&type=style&index=0&id=4c9d04ee&prod&lang=scss&scoped=true"
import style1 from "./technological.vue?vue&type=style&index=1&id=4c9d04ee&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c9d04ee",
  null
  
)

export default component.exports